import script from "./AccordionListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionListItem.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionListItem.vue?vue&type=style&index=0&id=56d42a20&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56d42a20"]])

export default __exports__